var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialShareTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.576 6.04722C20.856 6.35922 20.112 6.57522 19.32 6.67122C20.136 6.19122 20.76 5.42322 21.048 4.48722C20.28 4.94322 19.44 5.25522 18.552 5.44722C17.832 4.67922 16.8 4.19922 15.672 4.19922C13.488 4.19922 11.736 5.97522 11.736 8.13522C11.736 8.44722 11.76 8.73522 11.832 9.02322C8.56798 8.87922 5.68798 7.29522 3.74398 4.91922C2.35198 7.41522 3.91198 9.47922 4.94398 10.1752C4.31998 10.1752 3.69598 9.98322 3.16798 9.69522C3.16798 11.6392 4.53598 13.2472 6.31198 13.6072C5.92798 13.7272 5.06398 13.7992 4.53598 13.6792C5.03998 15.2392 6.50398 16.3912 8.20798 16.4152C6.86398 17.4712 4.89598 18.3112 2.37598 18.0472C4.12798 19.1752 6.19198 19.8232 8.42398 19.8232C15.672 19.8232 19.608 13.8232 19.608 8.63922C19.608 8.47122 19.608 8.30322 19.584 8.13522C20.4 7.53522 21.072 6.83922 21.576 6.04722Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialShareTwitter);
export default __webpack_public_path__ + "static/media/social-share-twitter.0f39d58d1e1e1cd432afdeaf8f997ecf.svg";
export { ForwardRef as ReactComponent };